import { styled } from 'stitches.config'

export default styled('div', {
  background: '$neutralBgSubtle',
  $$shadowColor: '$colors$panelShadow',
  // Soft layered shadow for depth + hairline border for definition
  boxShadow:
    '0 1px 2px 0 rgba(0,0,0,0.05), 0 12px 32px -12px $$shadowColor, inset 0 1px 0 0 rgba(255,255,255,0.5)',
  border: '1px solid $panelBorder',
  borderRadius: 12,
  transition:
    'box-shadow 280ms cubic-bezier(0.22, 1, 0.36, 1), transform 220ms cubic-bezier(0.22, 1, 0.36, 1), border-color 200ms ease',
  variants: {
    hoverable: {
      true: {
        '&:hover': {
          transform: 'translateY(-3px)',
          borderColor: '$gray8',
          boxShadow:
            '0 2px 6px 0 rgba(0,0,0,0.06), 0 20px 44px -12px $$shadowColor, inset 0 1px 0 0 rgba(255,255,255,0.6)',
        },
      },
    },
  },
})
